import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Lock } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";

const Footer = () => {
  const { t } = useLanguage();
  const [contact, setContact] = useState({ phone: "", email: "", address_tr: "" });

  useEffect(() => {
    api.get("/site/contact").then((r) => setContact(r.data)).catch(() => {});
  }, []);

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F0E0C] text-[#FAF6EC] border-t border-[#1F1D1A]"
    >
      <div className="container-mag py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="font-display text-3xl">Fatma Hanım Konağı</div>
          <p className="mt-5 text-sm text-[#FAF6EC]/65 leading-[1.85] max-w-md">{t("footer.tagline")}</p>
          <div className="mt-8 inline-block h-px w-12 bg-[#A88A50]" />
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-mono text-[10px] uppercase tracking-[0.4em] text-[#A88A50] mb-5">
            {t("footer.links")}
          </h4>
          <ul className="space-y-3 text-sm text-[#FAF6EC]/80">
            <li><a href="/#rooms" className="hover:text-[#FAF6EC]">{t("nav.rooms")}</a></li>
            <li><a href="/#gallery" className="hover:text-[#FAF6EC]">{t("nav.gallery")}</a></li>
            <li><a href="/#safranbolu" className="hover:text-[#FAF6EC]">{t("nav.attractions")}</a></li>
            <li><Link to="/booking" className="hover:text-[#FAF6EC]" data-testid="footer-book">{t("nav.book")}</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="font-mono text-[10px] uppercase tracking-[0.4em] text-[#A88A50] mb-5">
            {t("footer.contact")}
          </h4>
          <ul className="space-y-4 text-sm text-[#FAF6EC]/80">
            {contact.phone && (
              <li className="flex items-start gap-3 ltr-numbers">
                <Phone size={14} className="mt-1 text-[#A88A50] shrink-0" />
                <a href={`tel:${contact.phone.replace(/\s/g, "")}`} className="hover:text-[#FAF6EC]">{contact.phone}</a>
              </li>
            )}
            {contact.email && (
              <li className="flex items-start gap-3">
                <Mail size={14} className="mt-1 text-[#A88A50] shrink-0" />
                <a href={`mailto:${contact.email}`} className="hover:text-[#FAF6EC] break-all">{contact.email}</a>
              </li>
            )}
            {contact.address_tr && (
              <li className="flex items-start gap-3">
                <MapPin size={14} className="mt-1 text-[#A88A50] shrink-0" />
                <span className="leading-relaxed">{contact.address_tr}</span>
              </li>
            )}
          </ul>

          <div className="mt-7 pt-5 border-t border-[#A88A50]/30">
            <Link
              to="/admin/login"
              data-testid="footer-admin-main"
              className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.34em] text-[#FAF6EC] bg-[#A88A50] hover:bg-[#FAF6EC] hover:text-[#0F0E0C] transition-colors px-5 py-3"
            >
              <Lock size={12} /> {t("nav.admin")}
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-[#1F1D1A]">
        <div className="container-mag py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="text-xs text-[#FAF6EC]/45">
            © {new Date().getFullYear()} Fatma Hanım Konağı. {t("footer.rights")}
          </div>
          <Link
            to="/admin/login"
            data-testid="footer-admin"
            className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.32em] text-[#A88A50] hover:text-[#FAF6EC] transition-colors"
          >
            <Lock size={11} /> {t("nav.admin")}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
